import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  input: {
    margin: [0, 0, theme.spacing(3), 0],
  },
  calculationsBar: {
    width: '100%',
    display: 'flex',
    marginBottom: theme.spacing(4),
    flexWrap: 'wrap',
    [theme.breakpoints.up('mobile')]: {
      justifyContent: 'space-between',
    },
  },
  calculationsItem: {
    width: '50%',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      marginBottom: 'unset',
      width: '33%',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/sharedComponents/Quiz/components/MortgageBalanceQuestion/useStyles.js